import { render, staticRenderFns } from "./otherPixFields.vue?vue&type=template&id=93009836&scoped=true"
import script from "./otherPixFields.vue?vue&type=script&lang=ts"
export * from "./otherPixFields.vue?vue&type=script&lang=ts"
import style0 from "./otherPixFields.vue?vue&type=style&index=0&id=93009836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93009836",
  null
  
)

export default component.exports